/**
 * The lazily loaded screens of the signed-in app. app.tsx builds its routes
 * from these, and the sidebar calls them on hover or focus, so the chunk is
 * usually loaded before the click (a second import() of a module is free).
 */
export const screens = {
  home: () => import("@/features/home/home-page"),
  calendar: () => import("@/features/calendar/calendar-page"),
  posts: () => import("@/features/posts/posts-page"),
  channels: () => import("@/features/channels/channels-page"),
  channelQueue: () => import("@/features/channels/channel-queue-page"),
  media: () => import("@/features/media/media-page"),
  analytics: () => import("@/features/analytics/analytics-page"),
  webhooks: () => import("@/features/automation/webhooks-page"),
  feeds: () => import("@/features/automation/feeds-page"),
  settings: () => import("@/features/settings/settings"),
  billing: () => import("@/features/billing/billing-page"),
  account: () => import("@/features/account/account-page"),
} as const;

export type ScreenId = keyof typeof screens;

/** Starts loading a screen's code; errors are ignored (the route retries on navigation). */
export function prefetchScreen(id: ScreenId) {
  void screens[id]().catch(() => undefined);
}
